import React from 'react';
import {useState, useEffect} from 'react';

import quotes from "./Quotes.js"

function QuoteBar(){

    const [quote, setQuote] = useState(quotes[0]);

    // alert(Math.floor(Math.random() * quotes.length))


    React.useEffect(() =>{
        let interval = setInterval(()=>{
            setQuote(quotes[Math.floor(Math.random() * quotes.length)])
        }, 5000)


        return function cleanup() {
            clearInterval(interval);
        }
        }
    )
    
    return(
        <p><span class="italic">"{quote.quote}"</span> ~ {quote.author}</p>
        )
    
}

export default QuoteBar;